import React from "react";
import FailureIcon from "../../icons/failure-icon";
import Text from "../typography/text";
import "./styles.css";

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatCurrency = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? currencyFormatter.format(parsed) : "$0.00";
};

const MESSAGE_BUILDERS = {
  warning: (thresholdValue) =>
    `This account’s balance past due has exceeded the threshold of ${formatCurrency(
      thresholdValue
    )}. Please make a payment for past due invoices as soon as possible.`,
  limit: (thresholdValue) =>
    `This account’s balance past due has exceeded the permitted limit of ${formatCurrency(
      thresholdValue
    )}. Order placement is currently disabled until the past due balance is reduced below this limit.`,
};

const PastDueAlert = ({ variant = "warning", thresholdValue, className = "" }) => {
  const messageBuilder = MESSAGE_BUILDERS[variant] || MESSAGE_BUILDERS.warning;
  const resolvedClassName = [
    "past-due-alert",
    variant === "limit" ? "past-due-alert-limit" : "past-due-alert-warning",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={resolvedClassName}>
      <FailureIcon className="past-due-alert-icon" width={16} height={16} />
      <Text className="past-due-alert-text">
        {messageBuilder(thresholdValue)}
      </Text>
    </div>
  );
};

export default PastDueAlert;
